module.exports = __webpack_public_path__ + "img/0117.a3cff2c9.png";